// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f7ab87b","455":"f02cd19c"}[chunkId] + ".chunk.js";
};